import { Action, PlacementStateInterface } from 'shared/interface';
import { FETCH_PLACEMENTS } from 'shared/store/action-types';

const initialState: PlacementStateInterface = {
	home: [],
	live: [],
	sport: [],
};

export const PlacementReducer = (state: PlacementStateInterface = initialState, action: Action): PlacementStateInterface => {
	switch (action.type) {
		case FETCH_PLACEMENTS:
			return { ...state, ...action.payload };
		default:
			return state;
	}
};
